<template>
  <div>
    <loader :loader="sending" />
    <div class="wrapper-content">
      <v-row>
        <v-col class="d-flex justify-start">
          <v-btn color="error" outlined @click="returnLogin()" class="mr-4">
            <v-icon left>mdi-chevron-left</v-icon>
            regresar
          </v-btn>
        </v-col>
        <v-col  cols="12" md="7" xl="7" sm="12" class="d-flex justify-start">
          <span class="color-header">
            Control de cambios
            <v-icon medium right>mdi-clipboard-text-outline</v-icon>
          </span>
        </v-col>
      </v-row>

      <div class="separator20-50"></div>
      <v-card>
        <v-card-text>
          <div name="info" v-if="info">
            <component key="info" :is="info" />
            <v-row dense> </v-row>
          </div>
          <br />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import Loader from "@/app/components/base/loader/Loader.vue";
export default {
  name: "ReadView",
  components: {
    Loader,
  },
  data() {
    return {
      sending: false,
      encabezado: null,
      info: null,
    };
  },
  async mounted() {
    this.info = (await this.$route.meta.info()).default;
    this.encabezado = this.$route.meta.header;
  },
  methods: {
    returnLogin() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>
